"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsoleTelemetryExporter = void 0;
/**
 * ConsoleTelemetryExporter does nothing with exported events but record them
 * to console.
 */
class ConsoleTelemetryExporter {
    exportEvents(events) {
        events.forEach((e) => {
            console.log("export event", { e });
        });
        return Promise.resolve();
    }
}
exports.ConsoleTelemetryExporter = ConsoleTelemetryExporter;
//# sourceMappingURL=console.js.map